import { invoiceSettingsSlice } from '../slices/invoiceSettingsSlice';

export default invoiceSettingsSlice.reducer;

